import {
    Typography,
    Grid,
    useTheme,
    Box,
    IconButton,
    useMediaQuery,
} from '@mui/material'
import { KeyboardArrowRight } from '@mui/icons-material';
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import LinkRouter from '../../../components/LinkRouter';
import BreadcrumbsComponent from '../../../components/BreadcrumbsComponent';

import { IBreadcrumb } from '../../../components/BreadcrumbsComponent/types';
import { ForPartnersBoxStyle, ForPartnersIconButtonStyle } from './styled';
import HideForms from '../../../components/SendPulseForms/hide';




const ForPartners = () => {
    const { palette } = useTheme();
    const theme = useTheme();
    const navigate = useNavigate();

    const isXs = useMediaQuery(theme.breakpoints.down("md"));

    const [breadcrumbs, setBreadcrumbs] = useState<Array<IBreadcrumb>>([
        { name: "Партнерам", urlSlug: "" },
    ]);

    useEffect(() => {
        document.title = `Партнерам`;

    }, [])

    return (
        <>
            <HideForms />
            <Box sx={{ my: { xs: "11px", md: "28px", lg: "20px" }, mb: { xs: "28px", md: "0px" } }}>
                <BreadcrumbsComponent elements={breadcrumbs} />
            </Box>
            <Typography variant="h1" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "26px", md: "24px", lg: "36px" }} lineHeight="38px"  >
                Партнерам
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", mt: { xs: "28px", lg: "34px" } }}>
                <ForPartnersBoxStyle
                    background={`${palette.primary.dark}`}
                    onClick={() => { navigate("/for-public-and-charitable-organizations"); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                    sx={{ mb: { xs: "14px", md: "0px" } }}
                >
                    <Typography variant="h3" fontFamily="Druk Wide, sans-serif" lineHeight={{ xs: "28px", lg: "38px" }} color="inherit" fontWeight="bold" sx={{ fontSize: { xs: "16px", lg: "h3.fontSize" } }}>
                        Громадським та благодійним організаціям
                    </Typography>
                    <ForPartnersIconButtonStyle
                        disableRipple
                        size="large"
                        customColor='#fff'
                    >
                        <KeyboardArrowRight fontSize="inherit" sx={{ width: "inherit", height: "inherit" }} />
                    </ForPartnersIconButtonStyle>
                </ForPartnersBoxStyle>
                <ForPartnersBoxStyle
                    background={`${palette.text.secondary}`}
                    onClick={() => { navigate("/for-youth-spaces-and-centers"); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                >
                    <Typography variant="h3" fontFamily="Druk Wide, sans-serif" lineHeight={{ xs: "28px", lg: "38px" }} color="primary.dark" fontWeight="bold" sx={{ fontSize: { xs: "16px", lg: "h3.fontSize" } }}>
                        Молодіжним просторам та центрам
                    </Typography>
                    <ForPartnersIconButtonStyle
                        disableRipple
                        size="large"
                        customColor={`${palette.background.default}`}
                    >
                        <KeyboardArrowRight fontSize="inherit" sx={{ width: "inherit", height: "inherit" }} />
                    </ForPartnersIconButtonStyle>
                </ForPartnersBoxStyle>
            </Box >
            <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", my: { xs: "14px", lg: "20px" } }}>
                <ForPartnersBoxStyle
                    background={`${isXs ? palette.primary.dark : palette.text.secondary}`}
                    onClick={() => { navigate("/for-grantors"); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                    sx={{ mb: { xs: "14px", md: "0px" } }}
                >
                    <Typography variant="h3" fontFamily="Druk Wide, sans-serif" lineHeight={{ xs: "28px", lg: "38px" }} color={(isXs ? "inherit" : "primary.dark")} fontWeight="bold" sx={{ fontSize: { xs: "16px", lg: "h3.fontSize" } }}>
                        Грантодавцям
                    </Typography>
                    <ForPartnersIconButtonStyle
                        disableRipple
                        size="large"
                        customColor={`${isXs ? "#fff" : palette.background.default}`}
                    >
                        <KeyboardArrowRight fontSize="inherit" sx={{ width: "inherit", height: "inherit" }} />
                    </ForPartnersIconButtonStyle>
                </ForPartnersBoxStyle>
                <ForPartnersBoxStyle
                    background={`${isXs ? palette.text.secondary : palette.primary.dark}`}
                    onClick={() => { navigate("/for-cultural-institutions"); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                >
                    <Typography variant="h3" fontFamily="Druk Wide, sans-serif" lineHeight={{ xs: "28px", lg: "38px" }} color={(isXs ? "primary.dark" : "inherit")} fontWeight="bold" sx={{ fontSize: { xs: "16px", lg: "h3.fontSize" } }}>
                        Культурним установам
                    </Typography>
                    <ForPartnersIconButtonStyle
                        disableRipple
                        size="large"
                        customColor={`${isXs ? palette.background.default : "#fff"}`}
                    >
                        <KeyboardArrowRight fontSize="inherit" sx={{ width: "inherit", height: "inherit" }} />
                    </ForPartnersIconButtonStyle>
                </ForPartnersBoxStyle>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", mb: { xs: "43px", lg: "150px" } }}>
                <ForPartnersBoxStyle
                    background={`${palette.primary.dark}`}
                    onClick={() => { navigate("/for-educational-institutions"); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                    sx={{ mb: { xs: "14px", md: "0px" } }}
                >
                    <Typography variant="h3" fontFamily="Druk Wide, sans-serif" lineHeight={{ xs: "28px", lg: "38px" }} color="inherit" fontWeight="bold" sx={{ fontSize: { xs: "16px", lg: "h3.fontSize" } }}>
                        Освiтнiм закладам
                    </Typography>
                    <ForPartnersIconButtonStyle
                        disableRipple
                        size="large"
                        customColor='#fff'
                    >
                        <KeyboardArrowRight fontSize="inherit" sx={{ width: "inherit", height: "inherit" }} />
                    </ForPartnersIconButtonStyle>
                </ForPartnersBoxStyle>
                <ForPartnersBoxStyle
                    background={`${palette.text.secondary}`}
                    onClick={() => { navigate("/for-media"); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                >
                    <Typography variant="h3" fontFamily="Druk Wide, sans-serif" lineHeight={{ xs: "28px", lg: "38px" }} color="primary.dark" fontWeight="bold" sx={{ fontSize: { xs: "16px", lg: "h3.fontSize" } }}>
                        Медiа
                    </Typography>
                    <ForPartnersIconButtonStyle
                        disableRipple
                        size="large"
                        customColor={`${palette.background.default}`}
                    >
                        <KeyboardArrowRight fontSize="inherit" sx={{ width: "inherit", height: "inherit" }} />
                    </ForPartnersIconButtonStyle>
                </ForPartnersBoxStyle>
            </Box>
        </>
    )
}

export default ForPartners